// extracted by mini-css-extract-plugin
module.exports = {"label":"StatusLabel_label__lgcrV","success":"StatusLabel_success__15T4X","info":"StatusLabel_info__3QqAT","error":"StatusLabel_error__1rQyE"};